<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M11.1246 8C10.7575 8.94196 10.1378 9.76452 9.33375 10.3773C8.52967 10.9901 7.57225 11.3694 6.56666 11.4736C5.56108 11.5777 4.54623 11.4027 3.63362 10.9678C2.72101 10.5328 1.94594 9.85472 1.39355 9.008"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path class="v-icon-fill-color" d="M12,1 V5 L7.5,4.5 L12,1 Z" />
      <path
        d="M0.875 3.99992C1.2421 3.05796 1.86173 2.2354 2.66581 1.62261C3.46988 1.00982 4.42731 0.630511 5.43289 0.526346C6.43848 0.42218 7.45332 0.597193 8.36593 1.03216C9.27855 1.46712 10.0536 2.1452 10.606 2.99192"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path class="v-icon-fill-color" d="M-1,12 V7 L4.5,7.5 L-1,12 Z" />
    </g>
  </svg>
</template>
